import "../../utils/tailwind.css";
import Button from "../Buttons";
import Close from "../svg/close";

export default function Modal(props) {
  const { isModalOpen, setIsOpen, title = "", desc = "", handleSubmit, confirmButtonLabel = "Save", cancelButtonLabel = "Discard" } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSaveClick = () => {
    handleSubmit && handleSubmit();
  };

  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
          <div className="bg-white p-6 shadow-lg w-[554px] h-[284px] rounded-[20px] flex flex-col justify-center items-center">
            <Close role="button" tabIndex={0} className="!text-[black] ml-auto mb-auto cursor-pointer" onClick={handleClose} />
            <p className="font-[500] text-[31px] text-[#2C2C2C] mb-8">{title}</p>
            <p className="font-[400] text-[16px] text-[#2C2C2C] mb-8">{desc}</p>
            <div className="bg-white flex justify-end items-center py-3 rounded-lg pr-4 space-x-3">
              <Button variant="outline" className="w-[7rem] !text-[16px]" onClick={handleClose}>
                {cancelButtonLabel}
              </Button>
              <Button className="w-[7rem] !text-[16px]" onClick={handleSaveClick}>
                {confirmButtonLabel}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
